import { NgModule, Pipe, PipeTransform } from "@angular/core";
import { CommonModule } from "@angular/common";

@Pipe({
  name: 'reportingTime'
})
export class ReportingTimePipe implements PipeTransform {

  transform(value: unknown, hours: string | 'h', min: string | 'min'): unknown {

    if (typeof value === 'number') {
      const d = Number(value);
      const h = Math.floor(d / 3600);
      const m = Math.floor(d % 3600 / 60);
      const s = Math.floor(d % 3600 % 60);
      if(h + m == 0){
        console.log('reporting time: ' + s)
        return s + ' s'
      }
      const hDisplay = h > 0 ? h + ' ' + hours : '';
      const mDisplay =  m > 0 ? ' '+ m + ' ' + min : '';
      // let sDisplay = s + 's';

      // if ((h !== 0 || m !== 0)) {
      //   sDisplay = '';
      // }
      return hDisplay + mDisplay;
    } else {
      return '0';
    }

  }


}
@NgModule({
  imports: [CommonModule],
  declarations: [ReportingTimePipe],
  exports: [ReportingTimePipe],
})
export class ReportingTimeModule {}
